// extracted by mini-css-extract-plugin
export default {"bgVideoWrapper":"BgVideoWord_bgVideoWrapper__jamgV"};